import * as React from "react";
const SvgSquarePen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 15 15"
    {...props}
  >
    <path
      stroke="#111"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 1.664H2.333A1.333 1.333 0 0 0 1 2.998v9.333a1.333 1.333 0 0 0 1.333 1.333h9.334A1.334 1.334 0 0 0 13 12.331V7.664m-1.75-6.25a1.414 1.414 0 1 1 2 2l-6.009 6.01a1.33 1.33 0 0 1-.568.336l-1.916.56a.334.334 0 0 1-.413-.413l.56-1.915c.063-.215.179-.41.337-.568z"
    />
  </svg>
);
export default SvgSquarePen;
